Vue.component('test-2-button-counter', {
    template: `
        <button class="btn btn-primary" apfDontDisableOnSubmit="true" v-on:click="count++">
            Clicked {{ count }} times.
        </button>
    `,
    data: function () {
        return {
            count: 0
        }
    },
})